import React from 'react';
import { MobileAppearance } from '../AppearanceComponents/Mobile';
export default function Mobile(_a) {
    var editorView = _a.editorView, maxHeight = _a.maxHeight, editorDOMElement = _a.editorDOMElement;
    return (React.createElement(MobileAppearance, { editorView: editorView || null, maxHeight: maxHeight }, editorDOMElement));
}
//# sourceMappingURL=Mobile.js.map